<template>
  <div class="text-center">
    <v-dialog v-model="visible" width="800" persistent>
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye</v-icon> Visualizar Termo
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-row class="d-flex justify-center mt-7">
            <v-col cols="6">
              <v-text-field
                :value="content.nome"
                label="Nome do Termo*"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :value="content && content.tipo && content.tipo.descricao"
                label="Tipo de Termo*"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-center">
            <v-col cols="6">
              <v-text-field
                :value="content.dataInicio | date"
                label="Data Início*"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :value="content.dataFim | date"
                label="Data Fim*"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-center">
            <v-col cols="12" class="d-flex align-center">
              <div class="mr-4">Ações*:</div>
              <v-radio-group v-if="content && content.acao" v-model="content.acao.id" :disabled="true" row>
                <div class="d-flex flex-row">
                  <v-radio
                    v-for="n in itemsRadioButtomAcoes"
                    :value="n.id"
                    :key="n.id"
                    :label="n.descricao"
                    class="mr-4"
                  ></v-radio>
                </div>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-center">
            <v-col cols="12">
              <sigfoco-editor-html v-model="content.conteudo" disabled></sigfoco-editor-html>
            </v-col>
          </v-row>
        </div>
        <div class="btn-group text-center">
          <v-btn color="primary" @click="$emit('onClose')">
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
  
  <script>
  import { DialogProps } from '~/commons/classes/dialog-props';
  import { Termo } from '~/commons/classes/termo';
  import TermoService from '~/services/manter-termo.service';
  
  export default {
    props: new DialogProps(Termo),
    mixins: [TermoService],
    data() {
      return {
        itemsRadioButtomAcoes: [],
      };
    },
    mounted() {
      this.$buscarAcoes({ params: { ativo: true } }).then(({ data }) => {
        this.itemsRadioButtomAcoes = data.lista;
      });
    },
  };
</script>

  